<template>
  <li class="table_collumns-col">
    <div class="table_collumns-title">
      <i :class="banner" aria-hidden="true"></i>
      {{ title }}
    </div>
    <div class="table_collumns-line">
      <span class="data">{{ metric.box_hits }}</span>
      {{ $t('report.metrics.total_visits') }}
    </div>
    <div class="table_collumns-line">
      <span class="data">{{ metric.unanswered_submissions_count }}</span>
      {{ $t('report.metrics.visits_without_answers') }}
    </div>
    <div class="table_collumns-line">
      <span class="data">{{ metric.uncompleted_submissions_count }}</span>
      {{ $t('report.metrics.quizzes_not_completed') }}
    </div>
    <div class="table_collumns-line">
      <span class="data">{{ metric.completed_submissions_count }}</span>
      {{ $t('report.metrics.quizzes_completed') }}
    </div>
    <div class="table_collumns-line">
      <span class="data">{{ metric.conclusion_rate }}</span>
      {{ $t('report.metrics.completion_rate') }}
    </div>
    <div class="table_collumns-line">
      <span class="data">{{ metric.conclusion_average_time }}</span>
      {{ $t('report.metrics.average_time_to_complete') }}
    </div>
  </li>
</template>

<script>
  export default {
    name: 'Device',
    props: {
      metric: Object,
      banner: String,
      title: String,
    },
  };
</script>



/** WEBPACK FOOTER **
 ** Device.vue?895467aa
 **/